let PostureChart = function (props) {
  let { series } = props;

  let data = series.filter(function ({ value }) {
    return value !== null && value.c !== "NA" && value.s !== "NA";
  });

  let domain = [-90, -45, 45, 90];
  let range = [0, 15, 235, 250];
  let scale = d3.scaleLinear().domain(domain).range(range);
  let node = d3.select(".rc-posture-chart-data");
  let dots = node.selectAll("circle").data(data, (d) => d.ts);

  dots
    .enter()
    .append("circle")
    .attr("r", 3)
    .attr("cx", (d) => scale(d.value.ca))
    .attr("cy", (d) => scale(d.value.sa));

  dots
    .exit()
    .remove();

  return (
    <svg className="rc-posture-chart" width="250" height="250">
      <image xlinkHref="./img/rc/posture.svg" width="250" height="250"/>
      <g className="rc-posture-chart-data"/>
    </svg>
  );
};

module.exports = PostureChart;